import React from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Container, Row, Col} from "react-bootstrap";
import Img from "../../images/life-at-tekrevol/slide1.webp";
import Img1 from "../../images/life-at-tekrevol/slide2.webp";
import Carousel from 'react-bootstrap/Carousel';


function SliderTekrevol(props) {
    return (
        <div className="tekrevol_dark_bg slider_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Work-Life">
                            <h2>The Right Work-Life Balance</h2>
                        </div>
                        <div>
                            <p>We know that work isn't the only thing that matters. That's why we strive to create a
                                positive, supportive culture that values diversity and work-life balance. We offer
                                flexible scheduling, remote work options, and a variety of company-sponsored events and
                                activities.</p>
                            <p>We believe that great things happen when talented people come together and collaborate.
                                If you're excited about making a real impact through technology, we invite you to apply
                                and become a part of the TekRevol family!</p></div>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto text-center">
                        <Carousel fade controls={false} indicatorLabels={true}>

                            <Carousel.Item>
                                <div className="slider_image_item">
                                    <LazyLoadImage
                                        src={Img}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>

                            </Carousel.Item>

                            <Carousel.Item>
                                <div className="slider_image_item">
                                    <LazyLoadImage
                                        src={Img1}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </Carousel.Item>


                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default SliderTekrevol;